var map = {
	"./pcBlack/introduceIcon1-1.png": 640,
	"./pcBlack/introduceIcon2-1.png": 732,
	"./pcBlack/introduceIcon3-1.png": 5330,
	"./pcBlack/introduceIcon4-1.png": 7698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9842;